import * as React from 'react'

type TProps = {
    visible: boolean,
    onTimeout: () => void
    duration?: number
}

export const FlashMessage: React.FC<TProps> = ({visible, onTimeout, duration = 3000, children}) => {
  React.useEffect(() => {
    if (!visible) return;
    const id = setTimeout(onTimeout, duration);
    return () => clearTimeout(id);
  }, [visible, duration, onTimeout]);

  return visible ? <>{children}</> : null;
}

export default FlashMessage